"use client";

import { useTranslations } from "next-intl";
import { LegalDocumentBody, DocLinkRenderer } from "../LegalDocumentBody";
import { lp, LegalPart, LegalDocumentProps } from "../helpers";

// The Collection Statement is the same for all countries (no entity substitution).
const PARTS: LegalPart[] = [
  lp.paragraph("para1"),
  lp.paragraph("para2"),
  lp.paragraph("para3"),
  lp.paragraph("para4"),
  lp.list("infoList"),
  lp.paragraph("para5"),
  lp.paragraph("para6"),
  lp.paragraph("confirm"),
];

// `onOpenDoc` (enrollment only) makes the tagged document names in para2
// clickable to open each policy/terms; on the /legal page they render plain.
export function CollectionStatement({
  onOpenDoc,
}: LegalDocumentProps & { onOpenDoc?: (doc: string) => void }) {
  const t = useTranslations("collectionStatement");

  const renderDocLink: DocLinkRenderer | undefined = onOpenDoc
    ? (tag, text) => (
        <span
          className="doc-link"
          role="button"
          tabIndex={0}
          onClick={() => onOpenDoc(tag)}
        >
          {text}
        </span>
      )
    : undefined;

  return (
    <LegalDocumentBody
      t={t}
      titleKey="title"
      parts={PARTS}
      renderDocLink={renderDocLink}
    />
  );
}
